<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>经销商活动管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-col :span="8" class="buttomM">
        <el-input placeholder="请输入用户名称" v-model="queryInfo.query" clearable @clear="getUserList">
          <el-button slot="append" icon="el-icon-search" @click="getUserList"></el-button>
        </el-input>
      </el-col>
      <div class="leftM">提示：同一个经销商同一件商品只能参与一个活动</div>
      <el-table :data="userlist" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="经销商名称" prop="agencyName"></el-table-column>
        <el-table-column label="活动名称" prop="user_activitys">
          <template slot-scope="scope">
            <el-tag type="success" v-for="item in scope.row.user_activitys" :key="item" :label="item" :value="item">{{ item }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="最后编辑人" prop="lastman" width="130px"></el-table-column>
        <el-table-column label="最后编辑时间" prop="lasttime" width="130px"></el-table-column>
        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="editById(scope.row)">编辑活动</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[3, 5, 10, 15]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 修改用户的活动 -->
    <el-dialog title="修改活动" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <div v-for="item in catelist" :key="item.id">
        <el-checkbox v-model="item.check" @change="checkChange(item.id)">"{{ item.name }}"</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editActivityInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      canLook: 1,
      checked: true,
      // 查询条件
      // 获取用户列表的参数对象
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10
      },
      // 商品分类的数据列表，默认为空
      userlist: [],
      catelist: [],
      //勾选的
      checkSelectlist: [],
      // 总数据条数
      total: 0,
      editDialogVisible: false,
      selectId: null,
      selectPhone: null,
    }
  },
  created () {
    this.getUserList()
    // this.getActivityList()
  },

  methods: {
    checkChange (data) {
      console.log(data);

      if (!this.checkSelectlist.includes(data)) {
        this.checkSelectlist.push(data);
      } else {
        var index = this.checkSelectlist.indexOf(data);
        if (index > -1) { //大于0 代表存在，
          this.checkSelectlist.splice(index, 1);//存在就删除
        }
      }
      console.log(this.catelist);
    },

    //确定
    async editActivityInfo () {
      // if (this.checkSelectlist.length > 0) {
      const { data: res } = await this.$http.post('admin/activity/setUserActivitys', {
        data: this.checkSelectlist,
        phone: this.selectPhone,
      })
      if (res.code !== 200) {
        return this.$message.error(res.message)
      }
      this.$message.success('操作成功！')
      this.checkSelectlist = [];
      this.catelist = [];
      // this.userlist=[];
      this.getUserList();
      // }

      this.editDialogVisible = false
    },

    editById (data) {
      this.selectId = data.id
      this.selectPhone = data.phone
      //获取此经销商已选的活动
      this.getActivityList(data.phone)
    },

    editDialogClosed () {
      this.editDialogVisible = false
    },

    // 获取此经销商已选的活动
    // async getActivityListByUsePhone (phone) {
    //   const { data: res } = await this.$http.get('admin/activity/getActivityByUsePhone', { params: { phone: phone } })
    //   if (res.code !== 200) {
    //     return this.$message.error('获取已选活动失败！')
    //   }
    //   console.log(res.result)
    // },

    // 获取活动列表数据phone
    async getActivityList (phone) {
      const { data: res } = await this.$http.get('admin/activity/getAllActivityList', { params: { phone: phone } })
      if (res.code !== 200) {
        return this.$message.error('获取活动列表失败！')
      }
      console.log(res.result)
      // 把数据列表，赋值给 catelist
      this.catelist = res.result
      this.catelist.forEach(function (element, index) {
        if (element.check) {
          this.checkSelectlist.push(element.id);
        }
      }, this);

      this.editDialogVisible = true
      // 为总数据条数赋值
      // this.total = res.result.count
    },

    async getUserList () {
       if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
      const { data: res } = await this.$http.get('admin/user/getAllUsersWithActivityInUse', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('暂无用户列表！')
      }
      this.userlist = res.result.list
      this.total = res.result.count
     
      console.log(res)
    },

    // 监听 pagesize 改变
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getUserList()
    },
    // 监听 pagenum 改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getUserList()
    },

    // 点击按钮，展示添加分类的对话框
    showAddCateDialog () {
      this.addCateDialogVisible = true
    },

    // 新建活动
    goAddpage () {
      this.$router.push('/goods/addActivity')
    },

    // 编辑活动
    // editById (id) {
    //   this.$router.push({ path: '/goods/addActivity', query: { id: id } })
    // },

    // 点击按钮，添加新的分类
    addCate () {
      this.$refs.addCateFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/good/addGoodAttr', this.addCateForm)

        if (res.code !== 200) {
          return this.$message.error('添加分类失败！')
        }
        this.$message.success('添加分类成功！')
        this.getCateList()
        this.addCateDialogVisible = false
      })
    },

  }
}
</script>

<style lang="less" scoped>
.treeTable {
  margin-top: 15px;
}

.buttomM {
  margin-bottom: 15px;
}

.leftM {
  margin-left: 15px;
}

.el-cascader {
  width: 100%;
}
</style>
